import { useAuth } from "../contexts/AuthContext";
import { Toggle } from "./ui/toggle";
import { User, Users } from "@phosphor-icons/react";

/**
 * "My Records / All Records" segmented toggle.
 *
 * - For Sales: not rendered (server forces mine=true; no UX needed).
 * - For super_admin / accounts / viewer: rendered as a 2-button segmented
 *   control. Defaults to All (mine=false).
 *
 * Props:
 *   value:    current "mine" boolean (true = My, false = All)
 *   onChange: (next:boolean) => void
 *   testId:   data-testid base
 */
export const OwnershipToggle = ({ value, onChange, testId = "ownership-toggle" }) => {
    const { user } = useAuth();
    if (!user || user.role === "sales") return null;

    return (
        <div
            className="inline-flex items-center rounded-md border border-slate-200 bg-white p-0.5 shadow-sm"
            data-testid={testId}
            role="tablist"
            aria-label="Ownership filter"
        >
            <button
                type="button"
                onClick={() => onChange(true)}
                aria-selected={value === true}
                role="tab"
                data-testid={`${testId}-mine`}
                className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded text-xs font-medium transition-colors ${
                    value === true
                        ? "bg-slate-900 text-white"
                        : "text-slate-600 hover:bg-slate-50"
                }`}
            >
                <User size={12} weight={value === true ? "bold" : "regular"} />
                My Records
            </button>
            <button
                type="button"
                onClick={() => onChange(false)}
                aria-selected={value !== true}
                role="tab"
                data-testid={`${testId}-all`}
                className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded text-xs font-medium transition-colors ${
                    value !== true
                        ? "bg-slate-900 text-white"
                        : "text-slate-600 hover:bg-slate-50"
                }`}
            >
                <Users size={12} weight={value !== true ? "bold" : "regular"} />
                All Records
            </button>
        </div>
    );
};

export default OwnershipToggle;
